import { render, staticRenderFns } from "./annotate_canvas.vue?vue&type=template&id=097fe0d4&scoped=true&"
import script from "./annotate_canvas.vue?vue&type=script&lang=js&"
export * from "./annotate_canvas.vue?vue&type=script&lang=js&"
import style0 from "./annotate_canvas.vue?vue&type=style&index=0&id=097fe0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097fe0d4",
  null
  
)

export default component.exports